import { render, staticRenderFns } from "./ManageAccountIframe.vue?vue&type=template&id=7388ce44&"
import script from "./ManageAccountIframe.vue?vue&type=script&lang=ts&"
export * from "./ManageAccountIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports